import { Dialog } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { IoClose } from 'react-icons/io5';
import { TbSquareNumber1Filled, TbSquareNumber2Filled, TbSquareNumber3Filled, TbSquareNumber4Filled } from "react-icons/tb";


const ConfigurationModal = ({ displayModal, setDisplayModal }) => {

    const { t } = useTranslation('configuration_modal');

    const handleclose = () => {
        localStorage.setItem("configurationModal", true);
        setDisplayModal(false);

    }
    useEffect(() => {
        const returnmodal = localStorage.getItem("configurationModal");
        setDisplayModal(!returnmodal);
    }, [])
    return (
        <>
            {
                displayModal && (
                    <Dialog
                        open={true}
                        onClose={handleclose}
                        PaperProps={{
                            sx: {
                                borderRadius: "20px",
                                width: "630px",
                            },
                        }}

                    >
                        <div className="bg-white p-5 flex flex-col gap-3 rounded-[20px]">
                            <div className="grid gap-2">
                                <div className="flex  items-start justify-between w-full ">
                                    <span className='text-[18px] font-[600] text-[#131415] '>{t('header')}</span>
                                    <span onClick={handleclose}><IoClose size={25} className='cursor-pointer' /></span>
                                </div>
                                <p className='text-[15px] text-[#535861]'>{t('description')}</p>

                            </div>
                            <div className="bg-[#F6F6F6] p-3 rounded-[9px] grid gap-4 ">
                                <p className='font-[600] text-[#131415] text-[18px] ' >{t("how_to_proceed")}</p>
                                <div className='flex gap-2 text-[14px] items-start'>
                                    <span><TbSquareNumber1Filled fill='#3686FF' size={25} /></span>
                                    <p className='text-[#535861]'><span className='font-[600] text-[#131415]'>{t('personalize_message')}:</span> {t('personalize_message_desc')}</p>
                                </div>
                                <div className='flex gap-2 text-[14px] items-start'>
                                    <span><TbSquareNumber2Filled fill='#3686FF' size={25} /></span>
                                    <p className='text-[#535861]'><span className='font-[600] text-[#131415]'>{t('add_details')}:</span> {t('add_details_desc')}</p>

                                </div>
                                <div className='flex gap-2 text-[14px] items-start'>
                                    <span><TbSquareNumber3Filled fill='#3686FF' size={25} /></span>
                                    <p className='text-[#535861]'><span className='font-[600] text-[#131415]'>{t('use_examples')}:</span> {t('use_examples_desc')}</p>
                                </div>
                                <p className='text-[#535861] text-[14px] pl-1'>{t('create_messages_desc')}</p>

                                <div className='flex gap-2 text-[14px] items-start'>
                                    <span><TbSquareNumber4Filled fill='#3686FF' size={25} /></span>
                                    <p className='text-[#535861]'><span className='font-[600] text-[#131415]'>{t('confirm_sending')}:</span> {t('confirm_sending_desc')}</p>

                                </div>
                            </div>
                        </div>
                    </Dialog >
                )
            }
        </>
    )
}

export default ConfigurationModal